import React, { useLayoutEffect, useRef, createContext, useContext, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Platform } from 'react-native'
import { ThemeProvider as ElementsThemeProvider } from 'react-native-elements'
import { useSelector, useDispatch } from 'react-redux'
import THEMES from './../theme'
import { setTheme as setStoreTheme } from '../globalThemeReducer'

export const themeContext = createContext()

const buildEvergreenTheme = (defaultTheme, initTheme) => ({
  ...defaultTheme,
  overlayBackgroundColor: initTheme.OVERLAY,
  colors: {
    ...defaultTheme.colors,
    primary: ''
  },
  normalBorder: {
    ...defaultTheme.normalBorder,
    border: `1px solid ${initTheme.GEYSER}`
  },
  activeBorder: {
    ...defaultTheme.activeBorder,
    border: `1px solid ${initTheme.BUNKER}`
  },
  completeBorder: {
    ...defaultTheme.completeBorder,
    border: `1px solid ${initTheme.OUTER_SPACE}`
  },
  errorBorder: {
    ...defaultTheme.errorBorder,
    border: `1px solid ${initTheme.RED_ORANGE}`
  },
  principleShadows: {
    ...defaultTheme.principleShadows,
    boxShadow: `0 4px 16 0 ${initTheme.SLATE_GRAY}`
  }
})
const elementsativeTheme = initTheme => ({
  colors: {
    primary: initTheme.BUNKER,
    secondary: initTheme.LOCHMARA,
    divider: initTheme.ATHENS_GRAY
  }
})
export const ThemeProvider = ({ children }) => {
  const ThemeRef = useRef()
  const dispatch = useDispatch()
  const { ThemeProvider: EvergreenThemeProvider, defaultTheme } = ThemeRef?.current || {}
  const { theme: currentTheme } = useSelector(state => state.globalThemeReducer)
  const theme = THEMES[currentTheme || 'LIGHT_THEME']

  const setTheme = useCallback(selectedTheme => {
    dispatch(setStoreTheme(selectedTheme))
  }, [dispatch])

  useLayoutEffect(() => {
    if (Platform.OS === 'web') {
      import('evergreen-ui').then(importedModule => { ThemeRef.current = importedModule })
    }
  }, [])

  return (
    <themeContext.Provider value={{ theme, setTheme }}>
      <ElementsThemeProvider theme={elementsativeTheme(theme)}>
        {
          EvergreenThemeProvider ? (
            <EvergreenThemeProvider value={buildEvergreenTheme(defaultTheme, theme)}>
              <>{children}</>
            </EvergreenThemeProvider>
          ) : <>{children}</>
        }
      </ElementsThemeProvider>
    </themeContext.Provider>
  )
}

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export const useTheme = () => useContext(themeContext)
